import { useEffect } from 'react';
import GuestLayout from '@/Layouts/GuestLayout';
import { Head } from '@inertiajs/react';

export default function IndexPage({ status }: { status?: string }) {
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <GuestLayout>
      <Head title="Főoldal" />

      {status && (
        <div className="mb-4 mt-4 text-center font-medium text-sm text-green-600">
          {status}
        </div>
      )}

      <div className="mb-4 text-center text-sm text-grey-600">Linkek</div>

      <a
        href="https://skontakt.eu"
        className="underline text-sm text-gray-600  hover:text-gray-900  rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Főoldal
      </a>
    </GuestLayout>
  );
}
